import { Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// Dashboard
import Dashboard from "../component/dashboard/get/dashboard";
// Admins
import Admin from "../component/admin/get";
import AddAdmin from "../component/admin/add/add";
import EditAdmin from "../component/admin/edit/edit";
// Properties
import DuomoBlogs from "../component/properties/get";
import AddProperty from "../component/properties/add/add-properties";
import EditProperty from "../component/properties/edit/edit-properties";
// DraftProperty & UnpublishedPorperties
import DraftProperty from "../component/draft";
import UnpublishedPorperties from "../component/unpublished-properties";
// CrmProperties
import CrmProperties from "../component/crm-properties/get";
// Contact Us
import Contact from "../component/contact/get";
// SEO
import SEO from "../component/seo/get";
import AddSEO from "../component/seo/add/add";
import EditSEO from "../component/seo/edit/edit";
// Blogs
import Blogs from "../component/blogs/blogs";
import AddBlogs from "../component/blogs/create";
import EditBlogs from "../component/blogs/edit";
// OurTeam
import OurTeam from "../component/our-team/get/our-team";
import AddTeamMember from "../component/our-team/add/create";
import EditTeamMember from "../component/our-team/edit/edit";
// Events Contacts
import EventContacts from "../component/event-contacts/get";
// Carrers
import Carrers from "../component/carrers/get";
// Inquiry
import Inquiry from "../component/inquiry/get";
// login
import Login from "../component/login/login";
// Layout
import Layout from "../shared/layout";
// cookie
import cookie from "react-cookies";

const AllRoutes = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  // useEffect for loggedIn user to check
  useEffect(() => {
    let token = cookie?.load("token");
    if (token !== undefined) {
      // navigate(-1);
      setLoggedIn(true);
    } else {
      navigate("/login");
      setLoggedIn(false);
    }
    // eslint-disable-next-line
  }, [cookie?.load("token")]);

  return (
    <>
      {/* login page */}
      {!loggedIn ? (
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      ) : (
        <Layout>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            {/* Admin */}
            <Route path="/admin" element={<Admin />} />
            <Route path="/add-admin" element={<AddAdmin />} />
            <Route path="/edit-admin/:id" element={<EditAdmin />} />
            {/* Properties */}
            <Route path="/" element={<DuomoBlogs />} />
            <Route path="/add-property" element={<AddProperty />} />
            <Route path="/draft-property" element={<DraftProperty />} />
            <Route
              path="/unpublished-properties"
              element={<UnpublishedPorperties />}
            />
            <Route path="/edit-property/:id" element={<EditProperty />} />
            <Route path="/property-inquiry" element={<Inquiry />} />
            {/* CRM PROPERTY */}
            <Route path="/crm-properties" element={<CrmProperties />} />
            {/* Carrers */}
            <Route path="/carrers" element={<Carrers />} />
            {/* Contact */}
            <Route path="/contact" element={<Contact />} />
            {/* SEO */}
            <Route path="/seo" element={<SEO />} />
            <Route path="/add-seo" element={<AddSEO />} />
            <Route path="/edit-seo/:id" element={<EditSEO />} />
            {/* Blogs */}
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/add-blog" element={<AddBlogs />} />
            <Route path="/edit-blog/:id" element={<EditBlogs />} />
            {/* Teams */}
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/add-team" element={<AddTeamMember />} />
            <Route path="/edit-team/:id" element={<EditTeamMember />} />
            {/* Event contacts */}
            <Route path="/event-contacts" element={<EventContacts />} />
          </Routes>
        </Layout>
      )}
    </>
  );
};
export default AllRoutes;
